import { observer } from "mobx-react-lite";
import { ReactComponent as HoverLine } from "../../images/icons/hoverLine.svg";

const MenuSubElement = ({ name, link }) => {
    return (
        <a href={link} className={window.location.pathname == link ? "active":""}>
            <div className="name">{name}</div>
            <HoverLine/>
        </a>
    )
}

export default observer(MenuSubElement);